// src/ApiPanel/pages/ApiPanelComingSoon.jsx
import React from "react";

export default function ApiPanelComingSoon({ title }) {
  return (
    <div className="apip-card apip-coming-soon">
      <h2>{title}</h2>
      <p>
        This section is already wired into the API Panel navigation and route
        guard — it just needs its real content. Replace this component with
        the actual page whenever the backend endpoint for it is ready.
      </p>
    </div>
  );
}
